import registerDialog from './register-dialog';
import registeredDialogs from './registered-dialogs';
import getPositionByElement from './get-position-by-element';

export default {
  registerDialog,
  registeredDialogs,
  getPositionByElement,
};
